import type { FaireProductEntity } from "../../entity_types/product";

export const p_h9qr3w3h7y: FaireProductEntity = {
  token: "p_h9qr3w3h7y",
  type: "product",
  name: "HOT TWO TROT DRESS",
  brandToken: "b_2wtd67bx4w",
  brandName: "2 Fly Co",
  imageUrl:
    "https://cdn.faire.com/fastly/1d261d40b304e5d17947dbff48eaea66a12af574aea5001f2812652e6a8ee670.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/02e9f4047bad13253f168868b4926f364543699c38dd010b383f4443a40b15f7.png",
    "https://cdn.faire.com/fastly/b94fbc47818742d6a7ffbc2f9316cee9039cc8665112e79161fd9a5c771effab.png",
    "https://cdn.faire.com/fastly/b14474c308389705b15ef56330b8922fb46704726dcdd9bd36ab99c19a5df9ae.png",
  ],
  priceDollars: 23.95,
  description:
    "denim dress with LUCKY polka dots... say less. \nthis dress is a lightweight denim that is flowy and super comfy. \n| cuffed sleeves\n| printed horseshoe fabric is a super soft tee material\n| button collar neckline with pearl snap buttons \n| modest length\n\n55 COTTON | 40 TENCEL | 5 POLYESTER\n\nrunning true with room.\ndenim doesn't have much stretch.\nhorseshoe print fabric has stretch. \n\nS/M: 4-8\nL/XL: 10-16\n2X/3X: 18-24\n[estimated size. NOT exact.]\n\n\nwestern - dress - country - cowboy - cowgirl - farm - ranch - rodeo - back to school - teacher",
  tags: [],
  msrpDollars: 47.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:35.508Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
